var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 7.679688 0.957031 C 4.097656 0.855469 1.105469 3.691406 1.003906 7.273438 C 0.902344 10.855469 3.738281 13.851563 7.320313 13.953125 C 10.902344 14.050781 13.898438 11.21875 14 7.632813 C 14.019531 6.882813 13.90625 6.160156 13.6875 5.484375 L 12.863281 6.261719 C 12.960938 6.695313 13.011719 7.144531 13 7.609375 C 12.914063 10.640625 10.378906 13.035156 7.347656 12.953125 C 4.316406 12.867188 1.917969 10.332031 2 7.300781 C 2.085938 4.269531 4.621094 1.871094 7.652344 1.953125 C 8.644531 1.984375 9.566406 2.277344 10.359375 2.765625 L 11.109375 2.054688 C 10.125 1.398438 8.953125 0.992188 7.679688 0.957031 Z M 12.5 2.792969 L 6.5 8.792969 L 4.851563 7.148438 L 4.5 6.792969 L 3.792969 7.5 L 4.148438 7.851563 L 6.5 10.207031 L 13.207031 3.5 Z"}));
}

Check.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 16"};

module.exports = Check;

Check.default = Check;
